// Mock data for the redesigned dashboard widgets (design stage, no API yet).

import { format, subDays } from 'date-fns';
import { RecommendationCategory, RecommendationsProgress, RecommendationsRange } from '@/types/recommendations-progress';

// Recommendations completion mock: daily percents and category percents per period, ending today.
const RECOMMENDATIONS_DAILY_MOCK: Record<RecommendationsRange, number[]> = {
  7: [84, 40, 54, 20, 67, 72, 88],
  14: [72, 65, 48, 90, 35, 58, 81, 84, 40, 54, 20, 67, 72, 88],
  30: [
    55, 62, 70, 45, 38, 80, 92, 66, 51, 47, 73, 85, 60, 25, 58, 77,
    72, 65, 48, 90, 35, 58, 81, 84, 40, 54, 20, 67, 72, 88,
  ],
};

const RECOMMENDATIONS_CATEGORIES_MOCK: Record<RecommendationsRange, Record<RecommendationCategory, number>> = {
  7: { water: 30, food: 44, activity: 100, feeling: 10, medication: 86, tasks: 55 },
  14: { water: 42, food: 51, activity: 86, feeling: 24, medication: 79, tasks: 63 },
  30: { water: 48, food: 57, activity: 79, feeling: 33, medication: 82, tasks: 61 },
};

const CATEGORY_PLANNED_MOCK = 10;

export const recommendationsProgressMock = (days: RecommendationsRange): RecommendationsProgress => {
  const today = new Date();
  const daily = RECOMMENDATIONS_DAILY_MOCK[days].map((percent, i) => {
    const planned = 4 + ((i * 3) % 4);
    return {
      date: format(subDays(today, days - 1 - i), 'yyyy-MM-dd'),
      planned,
      completed: Math.round((planned * percent) / 100),
      percent,
    };
  });
  const planned = daily.reduce((sum, d) => sum + d.planned, 0);
  const completed = daily.reduce((sum, d) => sum + d.completed, 0);
  const categories = (Object.entries(RECOMMENDATIONS_CATEGORIES_MOCK[days]) as [RecommendationCategory, number][])
    .map(([category, percent]) => ({
      category,
      planned: CATEGORY_PLANNED_MOCK,
      completed: Math.round((CATEGORY_PLANNED_MOCK * percent) / 100),
      percent,
    }));
  return { days, average: Math.round((completed / planned) * 100), daily, categories };
};
